import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=6d835afa&scoped=true"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"
import style0 from "../assets/main.css?vue&type=style&index=0&id=6d835afa&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d835afa",
  null
  
)

export default component.exports